module.exports = __webpack_public_path__ + "static/media/google-support.9544c4b1.png";